export function GoogleIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 533.5 544.3" aria-hidden="true" className={className}>
      <path
        fill="#4285F4"
        d="M533.5 278.4c0-17.7-1.6-35.1-4.7-52H272v98.7h146.9c-6.4 34-25.3 62.7-54 82v68.2h87.3c51.1-47 81.3-116.2 81.3-196.9z"
      />
      <path
        fill="#34A853"
        d="M272 544.3c73.5 0 135.2-24.3 180.3-65.9l-87.3-68.2c-24.2 16.3-55.2 25.9-93 25.9-71.7 0-132.5-48.3-154-113.4h-90.2v71.2C77.7 475.9 168.7 544.3 272 544.3z"
      />
      <path
        fill="#FBBC05"
        d="M118 322.6c-10.2-30.3-10.2-62.6 0-92.9V158.5H27.8C-9.3 226.2-9.3 318.1 27.8 385.9L118 322.6z"
      />
      <path
        fill="#EA4335"
        d="M272 107.7c39.9 0 75.9 13.8 104.1 40.8l78.1-78.1C407.2 24.3 345.5 0 272 0 168.7 0 77.7 68.4 27.8 158.5l90.2 71.2C139.5 156 200.3 107.7 272 107.7z"
      />
    </svg>
  );
}

export function DiscordIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="#5865F2" aria-hidden="true" className={className}>
      <path d="M20.317 4.3698a19.7913 19.7913 0 0 0-4.8851-1.5152.0741.0741 0 0 0-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 0 0-.0785-.037 19.7363 19.7363 0 0 0-4.8852 1.515.0699.0699 0 0 0-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 0 0 .0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 0 0 .0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 0 0-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 0 1-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 0 1 .0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 0 1 .0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 0 1-.0066.1276 12.2986 12.2986 0 0 1-1.873.8914.0766.0766 0 0 0-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 0 0 .0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 0 0 .0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 0 0-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z" />
    </svg>
  );
}
